module.exports = __webpack_public_path__ + "static/media/okr.69adf955.jpg";